import React from 'react';
import PropTypes from 'prop-types';

import Tier from './tier';

function renderPlusInfo() {
  return (
    <React.Fragment>
      <div className="tier__info-item">
        Send up to <strong>20GB</strong>
      </div>
      <div className="tier__info-item">
        <strong>100GB</strong> of storage
      </div>
    </React.Fragment>
  );
}

function renderUnlimitedInfo() {
  return (
    <React.Fragment>
      <div className="tier__info-item">
        Send files of <strong>any size</strong>
      </div>
      <div className="tier__info-item">
        <strong>500GB</strong> of storage
      </div>
    </React.Fragment>
  );
}

export const Tiers = ({ onTierSelect }) => {
  // The `data-route-context` on the links is required to navigate to the `/plus` page and hide the top content
  // so to only show the sign up form.
  return (
    <div className="tiers">
      <h2 className="tiers__title">Go big or go, er, bigger</h2>
      <p className="tiers__subtitle">
        Whatever the files, whatever the size - choose the option that fits you
        best.
      </p>
      <div className="tiers__list">
        <Tier title="For big ideas" price={12} renderInfo={renderPlusInfo}>
          <a
            className="button button--enabled"
            data-route-context="plusform"
            data-tier="plus"
            onClick={onTierSelect}
          >
            Twenty is plenty
          </a>
        </Tier>
        <Tier
          title="For big(ger) ideas"
          price={19}
          renderInfo={renderUnlimitedInfo}
        >
          <a
            className="button button--enabled"
            data-route-context="plusform"
            data-tier="unlimited"
            onClick={onTierSelect}
          >
            The sky's the limit
          </a>
        </Tier>
      </div>
    </div>
  );
};

Tiers.propTypes = {
  onTierSelect: PropTypes.func.isRequired,
};

export default React.memo(Tiers);
